import { defineMessages } from 'react-intl';

export default defineMessages({
  surnames: 'Surnames',
  tipSurnames: '<strong>Tip:</strong> To quickly navigate to a surname board, enter the surname in the "Find a Board" search above.',
  noResults: 'There were no boards found.'
});
